import { ChangeEvent, useContext, useState } from "react";
import {
  SelectNameContext,
  SelectNameCtxContextProps,
} from "../../../context/CheckboxName";
import { EmailChecklistContext } from "../../../context/EmailChecklistContext";
import { SaveTemplateContext } from "../../../context/SaveTemplateContext";
import {
  SignTypeContext,
  SignTypeContextProps,
} from "../../../context/SignTypeContext";
import ArrowRight from "../../../svg/ArrowRight";
import DropdownIcon from "../../../svg/DropdownIcon";
import Checkbox from "../Checkbox";
import Modal from "../Modal";
import Radio from "../Radio";
import { Select } from "../Select";
import {
  AddField,
  ButtonAddField,
  ContainerMobile,
  Disable,
  Divider,
  Dropdown,
  EmailFieldWrapper,
  HiddenDivider,
  ModalButton,
  ModalContainer,
  ModalFormContent,
  ModalInput,
  ModalWrapperButton,
  ModalWrapperInput,
  RadioWrapper,
  Section,
  TitleSection,
  TitleTextFormModal,
  Visible,
} from "./styled";

export type Signatories = {
  email: string;
  document: string;
  color: string;
}[];
interface SideSettingsProps {
  signatoriesList: Signatories;
  collapse: boolean;
}

export default function SideSettings({
  signatoriesList,
  collapse,
}: SideSettingsProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenForm, setModalOpenForm] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [selectName, setSelectName] = useState("");
  const [emailOptions, setEmailOptions] = useState<string>(
    signatoriesList.length > 0 ? signatoriesList[0].email : ""
  );
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [additionalVisible, setAdditionalVisible] = useState(false);
  const [advancedVisible, setAdvancedVisible] = useState(true);

  const { emailChecklist, setEmailChecklist } = useContext(
    EmailChecklistContext
  );
  const { setSelectedOption } =
    useContext<SignTypeContextProps>(SignTypeContext);
  const { setSelectCtxName } =
    useContext<SelectNameCtxContextProps>(SelectNameContext);

  const { saveTemplate, setSaveTemplate } = useContext(SaveTemplateContext);

  const openModal = () => {
    setModalOpen(true);
    setTemplateName("");
    setSaveTemplate("");
  };

  const closeModal = () => {
    setModalOpen(false);
    setTemplateName("");
    setSaveTemplate("");
  };

  const openModalForm = () => {
    // setSelectedOption("select");
    setModalOpenForm(true);
  };

  const closeModalForm = () => {
    setSelectedOption("");
    setSelectName("");
    setModalOpenForm(false);
  };

  const handleSelectChange = (value: string) => {
    setEmailOptions(value);

    if (!emailChecklist[value]) {
      setEmailChecklist((prevEmailChecklist) => ({
        ...prevEmailChecklist,
        [value]: {
          send_self: false,
          signature_digital: false,
          order: 0,
        },
      }));
    }
  };

  const handleSelfCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setEmailChecklist((prevEmailChecklist) => ({
      ...prevEmailChecklist,
      [emailOptions]: {
        ...prevEmailChecklist[emailOptions],
        send_self: checked,
      },
    }));
  };

  const handlesignatureDigitalCheckboxChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = event.target;
    setEmailChecklist((prevEmailChecklist) => ({
      ...prevEmailChecklist,
      [emailOptions]: {
        ...prevEmailChecklist[emailOptions],
        signature_digital: checked,
      },
    }));
  };

  const handleTemplateName = (value: string) => {
    if (value.length >= 3) {
      setSaveTemplate(value);
      setModalOpen(false);
    }
    return;
  };

  const handleChangeSelectName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectName(e.target.value);
  };

  const handleSaveCheckbox = (event: any) => {
    if (selectName === "") {
      return;
    }
    setSelectCtxName(selectName);

    setSelectName("");
    setModalOpenForm(false);
  };

  const templateModal = () => {
    return (
      <Modal isOpen={modalOpen}>
        <ModalContainer>
          <h2>Salvar template</h2>
          <ModalWrapperInput>
            <label htmlFor="templateName">Nome do Template</label>
            <ModalInput
              type="text"
              id="templateName"
              value={templateName}
              onChange={(e: any) => setTemplateName(e.target.value)}
            />
          </ModalWrapperInput>
          <ModalWrapperButton>
            <ModalButton
              backgroundColor="#355B94"
              hoverBackgroundColor="#32568C"
              onClick={closeModal}
            >
              Cancelar
            </ModalButton>
            <ModalButton
              onClick={() => handleTemplateName(templateName)}
              backgroundColor="#77EC84"
              hoverBackgroundColor="#72E27F"
            >
              Salvar
            </ModalButton>
          </ModalWrapperButton>
        </ModalContainer>
      </Modal>
    );
  };

  const templateModalForm = () => {
    return (
      <Modal isOpen={modalOpenForm}>
        <ModalFormContent>
          <TitleTextFormModal>
            Nome que será associado às opções
          </TitleTextFormModal>
          <ModalInput
            type="text"
            value={selectName}
            onChange={(e: any) => handleChangeSelectName(e)}
            placeholder="Nome do Select"
          />

          <ModalWrapperButton>
            <ModalButton
              backgroundColor="#355B94"
              hoverBackgroundColor="#32568C"
              onClick={closeModalForm}
            >
              Cancelar
            </ModalButton>
            <ModalButton
              backgroundColor="#77EC84"
              hoverBackgroundColor="#72E27F"
              color="#2c2c2c"
              onClick={handleSaveCheckbox}
            >
              Confirmar
            </ModalButton>
          </ModalWrapperButton>
            <div style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
            Após clicar em confirmar e posicionar o elemento, escreva as opções separadas por vírgula.
            </div>
        </ModalFormContent>
      </Modal>
    );
  };

  return (
    <Section hasCollapse={collapse}>
      <div>
        <EmailFieldWrapper>
          <TitleSection>
            <span> E-mails dos</span> Signatários
          </TitleSection>
          {signatoriesList.length ? (
            <Select
              options={signatoriesList}
              value={emailOptions}
              onChange={handleSelectChange}
            />
          ) : (
            <p>Carregando...</p>
          )}
        </EmailFieldWrapper>
        <Divider />
        <AddField onClick={() => setDropdownVisible(!dropdownVisible)}>
          <TitleSection>Campos de Assinatura</TitleSection>
          <Dropdown isExpanded={dropdownVisible}>
            <DropdownIcon />
          </Dropdown>
        </AddField>
        <Visible visible={dropdownVisible}>
          <RadioWrapper>
            <Radio
              id="signature"
              name="sectiongroup"
              value="signature"
              label="Assinatura"
            />
            <Radio
              id="initial"
              name="sectiongroup"
              value="initial"
              label="Rubrica"
            />
          </RadioWrapper>
        </Visible>
        <ContainerMobile>
          <hr />
          <Radio
            id="signature"
            name="sectiongroup"
            value="signature"
            label="Assinatura"
          />
          <hr />
          <Radio
            id="initial"
            name="sectiongroup"
            value="initial"
            label="Rubrica"
          />
          <hr />
          <Radio id="text" name="sectiongroup" value="text" label="Texto" />
          <hr />
          <Radio id="cpf" name="sectiongroup" value="cpf" label="CPF" />
          <hr />
            <Radio id="cnpj" name="sectiongroup" value="cnpj" label="CNPJ" />
          <hr />
            <Radio id="date" name="sectiongroup" value="date" label="Data" />
          <hr />
          <Radio
            id="select"
            name="sectiongroup"
            value="select"
            label="Seleção"
            setOpenModal={() => setModalOpenForm(true)}
          />
          <hr />
          {templateModalForm()}
        </ContainerMobile>
        <Divider />
        <AddField onClick={() => setAdditionalVisible(!additionalVisible)}>
          <TitleSection>Campos Adicionais</TitleSection>
          <Dropdown isExpanded={additionalVisible}>
            <DropdownIcon />
          </Dropdown>
        </AddField>
        <Visible visible={additionalVisible}>
          <RadioWrapper>
            <Radio id="text" name="sectiongroup" value="text" label="Texto" />
            <Radio id="cpf" name="sectiongroup" value="cpf" label="CPF" />
            <Radio id="cnpj" name="sectiongroup" value="cnpj" label="CNPJ" />
            <Radio id="date" name="sectiongroup" value="date" label="Data" />
            <Radio
              id="select"
              name="sectiongroup"
              value="select"
              label="Seleção"
              setOpenModal={() => setModalOpenForm(true)}
            />
            {/* <FormWrapper checked={selectedOption === "select"} onClick={() => openModalForm()}>
              <SelectIcon />
              <FormButton >
                Seleção
              </FormButton>
              </FormWrapper> */}
            {templateModalForm()}
          </RadioWrapper>
        </Visible>
      </div>
      <Divider />
      <div style={{ cursor: "not-allowed" }}>
        <Disable>
          <AddField onClick={() => setAdvancedVisible(!advancedVisible)}>
            <TitleSection>Opções Avançadas</TitleSection>
            <Dropdown isExpanded={advancedVisible}>
              <DropdownIcon />
            </Dropdown>
          </AddField>
          <Visible visible={advancedVisible}>
            <Checkbox
              label="Assinatura Digital - eCPF"
              onChange={handlesignatureDigitalCheckboxChange}
              checked={emailChecklist[emailOptions]?.signature_digital || false}
            />
            <HiddenDivider />
            <Checkbox
              label="Autenticação por Foto - FaceID"
              onChange={handleSelfCheckboxChange}
              checked={emailChecklist[emailOptions]?.send_self || false}
            />
          </Visible>
        </Disable>
        <Divider />
        <AddField>
          <ButtonAddField
            saved={saveTemplate.length >= 3 ? true : false}
            onClick={saveTemplate.length < 3 ? () => openModal() : () => {}}
          >
            <ArrowRight />
            {saveTemplate.length >= 3 ? "Salvo" : "Salvar como modelo"}
          </ButtonAddField>
          {templateModal()}
        </AddField>
      </div>
    </Section>
  );
}
